import { clsx } from 'clsx';
import type { CardBrand } from '../../../utils/payments/mockCard';
import { CARD_BRAND_LABEL } from '../../../utils/payments/mockCard';

type BrandLogoProps = {
  brand: CardBrand;
  className?: string;
};

/**
 * Wordmark cerimonial das bandeiras. Texto puro em font-display sobre fundo
 * dourado transparente — mantém coerência com a estética sem usar logos reais
 * (que teriam restrições de uso). Suficiente pra detecção visual durante demo.
 */
export function BrandLogo({ brand, className }: BrandLogoProps) {
  if (brand === 'unknown') {
    return (
      <span
        className={clsx(
          'inline-flex h-7 items-center rounded-sm border border-gold/30 px-2 font-mono text-[10px] uppercase tracking-stamp text-champagne/60',
          className,
        )}
      >
        Cartão
      </span>
    );
  }

  return (
    <span
      className={clsx(
        'inline-flex h-7 items-center rounded-sm border border-gold/50 bg-gold/15 px-2 font-display text-xs font-semibold uppercase tracking-wider text-gold shadow-goldSoft',
        className,
      )}
    >
      {CARD_BRAND_LABEL[brand]}
    </span>
  );
}
